import { render, staticRenderFns } from "./xzJobnewsList.vue?vue&type=template&id=1fd47947&scoped=true"
import script from "./xzJobnewsList.vue?vue&type=script&lang=js"
export * from "./xzJobnewsList.vue?vue&type=script&lang=js"
import style0 from "./xzJobnewsList.vue?vue&type=style&index=0&id=1fd47947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd47947",
  null
  
)

export default component.exports